export const clearCookie = (
  cookie,
  path = "/",
  expires = "Thu, 01 Jan 1970 00:00:00 UTC"
) => {
  document.cookie = `${cookie}=; expires=${expires}; path=${path}; domain=${import.meta.env.VITE_APP_DOMAIN}`;
  console.log("cookie cleared")
};